import { useCallback, useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import OrderFullscreenModal from './common/OrderFullscreenModal';
import { useOrderContext } from '../../../../providers/OrderProvider';
import OrderFullscreenModalBody from './common/OrderFullscreenModalBody';
import OrderModalFooter from './common/OrderModalFooter';
import OrderModalHeader from './common/OrderModalHeader';
import OrderDetailModalBody from './common/OrderDetailModalBody';

const ApplyingModal = ({ setIsOpenPendingModal, isOpenPendingModal, onRequestWithdraw }) => {
	const { order, isLoading } = useOrderContext();
	const { orderId, customerInfo, approvalStatus, isCompleted } = order ?? {};

	const handleClose = useCallback(() => {
		setIsOpenPendingModal(false);
	}, [setIsOpenPendingModal]);

	const applyingStatusBadge = useMemo(() => order?.uiHints?.modalStatusBadges?.applying ?? null, [order]);

	return (
		<OrderFullscreenModal show={isOpenPendingModal} onHide={handleClose}>
			<OrderModalHeader
				orderId={orderId}
				customerInfo={customerInfo}
				isLoading={isLoading}
				isCompleted={isCompleted}
				approvalStatus={approvalStatus}
				badges={applyingStatusBadge ? [applyingStatusBadge] : []}
			/>
			<OrderFullscreenModalBody isLoading={isLoading}>
				<OrderDetailModalBody
					notesType='create'
					paymentScheduleModelName='ApplyingModal'
					contractTooltipId='applying-contract-toggle-tooltip'
					invoiceTooltipId='applying-invoice-toggle-tooltip'
				/>
			</OrderFullscreenModalBody>
			<OrderModalFooter>
				{onRequestWithdraw ? (
					<Button variant='primary' size='sm' onClick={onRequestWithdraw}>
						<FontAwesomeIcon icon='undo' className='fs-11 me-2' />
						撤回
					</Button>
				) : null}
			</OrderModalFooter>
		</OrderFullscreenModal>
	);
};

export default ApplyingModal;
